var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgBandcamp = function SvgBandcamp(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4C0 1.79086 1.79086 0 4 0H20C22.2091 0 24 1.79086 24 4V20C24 22.2091 22.2091 24 20 24H4C1.79086 24 0 22.2091 0 20V4Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 17L8.958 8H20L15.0413 17H4Z",
    fill: "#629AA9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4 1H20V-1H4V1ZM23 4V20H25V4H23ZM20 23H4V25H20V23ZM1 20V4H-1V20H1ZM4 23C2.34315 23 1 21.6569 1 20H-1C-1 22.7614 1.23858 25 4 25V23ZM23 20C23 21.6569 21.6569 23 20 23V25C22.7614 25 25 22.7614 25 20H23ZM20 1C21.6569 1 23 2.34315 23 4H25C25 1.23858 22.7614 -1 20 -1V1ZM4 -1C1.23858 -1 -1 1.23858 -1 4H1C1 2.34315 2.34315 1 4 1V-1Z",
    fill: "#DDDFE1"
  })));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgBandcamp);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTAgNEMwIDEuNzkwODYgMS43OTA4NiAwIDQgMEgyMEMyMi4yMDkxIDAgMjQgMS43OTA4NiAyNCA0VjIwQzI0IDIyLjIwOTEgMjIuMjA5MSAyNCAyMCAyNEg0QzEuNzkwODYgMjQgMCAyMi4yMDkxIDAgMjBWNFoiIGZpbGw9IndoaXRlIi8+CjxwYXRoIGQ9Ik00IDE3TDguOTU4IDhIMjBMMTUuMDQxMyAxN0g0WiIgZmlsbD0iIzYyOUFBOSIvPgo8cGF0aCBkPSJNNCAxSDIwVi0xSDRWMVpNMjMgNFYyMEgyNVY0SDIzWk0yMCAyM0g0VjI1SDIwVjIzWk0xIDIwVjRILTFWMjBIMVpNNCAyM0MyLjM0MzE1IDIzIDEgMjEuNjU2OSAxIDIwSC0xQy0xIDIyLjc2MTQgMS4yMzg1OCAyNSA0IDI1VjIzWk0yMyAyMEMyMyAyMS42NTY5IDIxLjY1NjkgMjMgMjAgMjNWMjVDMjIuNzYxNCAyNSAyNSAyMi43NjE0IDI1IDIwSDIzWk0yMCAxQzIxLjY1NjkgMSAyMyAyLjM0MzE1IDIzIDRIMjVDMjUgMS4yMzg1OCAyMi43NjE0IC0xIDIwIC0xVjFaTTQgLTFDMS4yMzg1OCAtMSAtMSAxLjIzODU4IC0xIDRIMUMxIDIuMzQzMTUgMi4zNDMxNSAxIDQgMVYtMVoiIGZpbGw9IiNERERGRTEiLz4KPC9zdmc+Cg==";